export default __webpack_public_path__ + "static/media/stmaryofangels.3eb13901.jpg";